<script lang="ts" setup>
import type { ChallengeRank, ChallengeType } from '~/types/challenge'

const { t } = useI18n()

const props = defineProps<{
  challengeType: ChallengeType
  rank: ChallengeRank
  valueClasses?: string
  unitClasses?: string
  climbUnitImperical?: string
  climbUnitMetric?: string
}>()
</script>

<template>
  <UnitItem v-if="props.challengeType === 'distance'" :value="props.rank.challenge_distance ?? 0">
    <template #value="{ value }">
      <span class="tw-font-bold" :class="valueClasses">{{ value }}&nbsp;</span>
    </template>

    <template #unit="{ unit }">
      <span :class="unitClasses">{{ unit }}</span>
    </template>
  </UnitItem>

  <UnitItem
    v-if="props.challengeType === 'climb'"
    :value="rank.challenge_climb ?? 0"
    :unit-to-imperical="props.climbUnitImperical"
    :unit-to-metric="props.climbUnitMetric"
  >
    <template #value="{ value }">
      <span class="tw-font-bold" :class="valueClasses">{{ value }}</span
      >&nbsp;
    </template>

    <template #unit="{ unit }">
      <span :class="unitClasses">{{ unit }}</span>
    </template>
  </UnitItem>

  <template v-if="props.challengeType === 'duration'">
    <DurationItem
      :duration="rank.challenge_duration ?? 0"
      class="tw-font-bold"
      :class="valueClasses"
    />
    &nbsp;

    <span :class="unitClasses">
      {{ t('Hours') }}
    </span>
  </template>

  <template v-if="props.challengeType === 'referral'">
    <span class="tw-font-bold" :class="valueClasses">{{ rank.challenge_referrals ?? 0 }}</span>
  </template>
</template>
